import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { sharedMiscStyle } from './sharednote.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import { styleColors } from 'src/main.style';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof sharedMiscStyle> {
  noteId:number;
  icon:string|undefined;
  avatar:number|undefined;
  title:string;
  selectedSharedNoteId:number|undefined;
  teaserText:string;
  lastTime:string;
  badge:boolean;
  deleted:boolean,
  family:IFamilyMember[],
  seenBy:Array<IFamilyMember|undefined>,
  onClick:() => void;
  isBeeingGenerated:boolean;
  iconIsBeeingGenerated:boolean;
}

class SharedNotListItem extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const {classes, noteId, icon, avatar, title, selectedSharedNoteId, teaserText, lastTime, 
      onClick, badge, deleted, family, seenBy} = this.props;
    const isUnseen = badge && noteId > 0;

    const style:React.CSSProperties = {};
    if (selectedSharedNoteId === noteId) {
      style.backgroundColor = styleColors.blackAlpha23;
    }
    if (deleted) {
      style.maxHeight = '0px';
      style.minHeight = "0px";
    }

    let iconImage:JSX.Element = <div/>;

    if (this.props.isBeeingGenerated || this.props.iconIsBeeingGenerated) {
      iconImage = <div className={classes.icon + " "+classes.skeletonBorder + " "+classes.skeletonBorderRound} 
      style={{border:`0px solid ${styleColors.greyDark2}`}} />;
    } else if (icon && icon.length > 1) {
      if (icon.startsWith("http")) {
        iconImage = <div className={classes.icon}>
          <img src={icon} className={classes.imageIcon} />
        </div>
      } else {
        iconImage = <div className={classes.icon}><img
          src={"logos/" + icon}
          className={classes.imageIcon}
          style={{backgroundColor: styleColors.softYellow}}/></div>
      }

    } else if (avatar && avatar > 0) {
      const avatarMember = family.find((mem) => mem.id === avatar);
      if (avatarMember !== undefined) {
        iconImage = <div className={classes.icon}><ImgAvatar
          key={avatarMember.id}
          altText={avatarMember.firstName}
          color={avatarMember.color}
          imgName={avatarMember.avatar}
          imgUrl={avatarMember.imageAvatar?avatarMember.avatarURL:undefined}
          style={{
            width: '100%',
            height: '100%',
          }}
        /></div>;
      } 
    } else {
      iconImage = <div className={classes.icon} />;
    }

    const itemTitle:JSX.Element = this.props.isBeeingGenerated
      ?<div style={{flex:1}}><div style={{minWidth: '55%',maxWidth: '55%',minHeight: '16px'}}  
        className={classes.skeletonBorder}/></div>
      :<div className={classes.shareNoteListItemTitle} style={!isUnseen && title.length===0?{color:styleColors.greyMedium2}:{}}>
          {title.length > 0 ? title : tn.lang.missingTitle }
        </div>

    const teaser:JSX.Element|string = this.props.isBeeingGenerated
      ?<div style={{flex:1}}><div style={{minWidth: '100%',maxWidth: '100%',minHeight: '16px',}}  
        className={classes.skeletonBorder}/></div>
      :teaserText || "\u00a0";

    return (
      <div className={classes.shareNoteListItem + (isUnseen ? " " + classes.shareNoteListItemUnseen : "")} onClick={onClick} style={style}>
        <div className={classes.shareNoteListItemIcon}>
          {iconImage}
        </div>
        <div className={classes.shareNoteListItemBody}>
          <div className={classes.shareNoteListItemTopRow}>
            {itemTitle}
            <div className={classes.shareNoteListItemTime}>{lastTime}</div>
          </div>
          <div className={classes.shareNoteListItemBottomRow}>
            <div className={classes.shareNoteListItemMessage}>
              {teaser}
            </div>
            { noteId < 0
              ?<div className={classes.shareNoteListItemSeenBy}>{tn.lang.notShared}</div>
              :isUnseen
              ?<div className={classes.shareNoteListItemSeenBy}>{tn.lang.sharedNoteUnseen}</div>
              :(seenBy.length > 0 && <div className={classes.shareNoteListItemSeenBy}>
                <div>{tn.lang.todoSeenBy}</div>
                {seenBy.map((mem) => (mem && <ImgAvatar key = {mem.id}
                  altText={mem.firstName} color={mem.color} imgName={mem.avatar}
                  imgUrl={mem.imageAvatar?mem.avatarURL:undefined} style={{width: '10px',height: '10px',}}/>))}
              </div>)
            }
          </div>
        </div>
      </div>
    );
  }

}


export default (withStyles(sharedMiscStyle)(SharedNotListItem));



// WEBPACK FOOTER //
// ./src/components/sharednotes/SharedNoteListItem.tsx